import React, { useEffect, useState } from "react";
import { Button, Typography, Modal, message } from "antd";
import { useB2BContext } from "../../context/ContextB2B";
import moment from "moment";
import { authSVC } from "../../services";
import { useNavigate } from "react-router-dom";
const { Text } = Typography;

function OnDemandService() {
  const { paymentDetails, getUserByID } = useB2BContext();
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [isModalOpenReference, setIsModalOpenReference] = useState(false);
  const [selectedOption, setSelectedOption] = useState<any>();
  const [packageData, setPackageData] = useState<any>();
  const navigate = useNavigate();
  const [copied, setCopied] = useState(false);
  const [referenceId, setReferenceId] = useState<any>();
  const [getCompanyOndemandService, setGetCompanyOndemandServiceIQ] =
    useState<any>();

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(referenceId);
      setCopied(true);
      message.success("Copied!");
      setTimeout(() => setCopied(false), 2000); // Reset after 2 sec
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  useEffect(() => {
    console.log(paymentDetails, "paymentDetails");
    console.log(getUserByID, "getUserByID");
  }, [paymentDetails, getUserByID]);

  const handleOkReference = () => {
    setIsModalOpenReference(true);
  };

  const handleCancelReference = () => {
    setIsModalOpenReference(false);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    if (getUserByID) {
      authSVC
        .getMappedPackageList(getUserByID?.company_id?._id)
        .then((res: any) => {
          console.log(res.data, "getMappedPackageList");
          setPackageData(res.data.package);
        })
        .catch((err: any) => {
          message.error(err.message);
        });
    }
  }, [getUserByID]);

  useEffect(() => {
    if (selectedOption) {
      authSVC
        .GetCompanyOndemandService(
          getUserByID?.company_id?._id,
          selectedOption?._id
        )
        .then((res: any) => {
          console.log(res.data, "GetCompanyOndemandService");
          setGetCompanyOndemandServiceIQ(res?.data?.modules);
          // setPackageData(res.data.package);
        })
        .catch((err: any) => {
          message.error(err.message);
        });
    }
  }, [selectedOption, getUserByID]);

  const RequestOndemandServiceClick = (id: any) => {
    authSVC
      .RequestOndemandService({ service_id: id })
      .then((res: any) => {
        console.log(res.data, "RequestOndemandService");
        setReferenceId(res?.data?.data?.reference_id);
        // setPackageData(res.data.package);
        setIsModalOpenReference(true);
      })
      .catch((err: any) => {
        message.error(err.message);
      });
  };

  return (
    <div className="manage_plan_wrapper">
      <div className="plan_info" style={{ width: "50%" }}>
        {/* <Text className="title24">your on demand services</Text> */}
        <div
          className="switch_plan_wrapper"
          onClick={() => setIsModalOpen(true)}
        >
          <div>
            <p>Subscription Plan</p>
            <h3>{selectedOption && selectedOption?.package}</h3>
          </div>
          <div>
            {packageData?.length === 1 ? <></> : <button>switch plan</button>}
          </div>
        </div>
        <div className="on_demand_service_wrapper">
          {getCompanyOndemandService &&
            getCompanyOndemandService?.map((module: any, moduleIndex: any) => (
              <div key={moduleIndex}>
                <h2>{module.moduleName}</h2>
                <ul>
                  {module &&
                    module?.moduleItem.map((item: any) => (
                      <li key={item._id}>
                        {" "}
                        <span>{item.moduleName} </span>
                        <button
                          onClick={() => RequestOndemandServiceClick(item._id)}
                        >
                          Request
                        </button>
                      </li>
                    ))}
                </ul>
              </div>
            ))}
        </div>

        {/* {getCompanyOndemandService?.map((data: any) => {
          return (
            <div>
              <h2>{data?.moduleName}</h2>
              <ul>
                {data?.moduleItem((item: any) => {
                  <li>{item?.moduleName}</li>;
                })}
              </ul>
            </div>
          );
        })} */}
        {/* <div className="content_wrapper subscription">
          {packageData === undefined ? (
            <></>
          ) : packageData ? (
            <>
              {packageData?.map((data: any) => {
                return (
                  <div className="plan_card">
                    <div className="cardHead">
                      <h1>{data?.package}</h1>
                      <div className="border"></div>
                      <p className="next">Active Plan</p>
                      <p className="price">₹{data?.price}</p>
                      <p className="date">
                        Expires On{" "}
                        {moment(data?.next_renewal_date).format("DD MMM YYYY")}
                      </p>
                      <button
                        className="view_addons"
                        onClick={() => {
                          ViewAddOns(data._id);
                          setPackageName(data.package);
                          setPackageId(data._id);
                        }}
                      >
                        View add-ons
                        <img src="/img/view_addons.svg" alt="" />
                      </button>
                    </div>

                    {packageData.length === 2 ? (
                      <></>
                    ) : data?.package === "PLATINUM" ? (
                      <></>
                    ) : (
                      <div className="cardFooter">
                        <Button className="btn" onClick={openPaymentUpdate}>
                          Upgrade Plan
                        </Button>
                      </div>
                    )}
                  </div>
                );
              })}
              {packageData.length === 2 ? (
                <></>
              ) : (
                <Button className="another_plan" onClick={RequestAnotherPlan}>
                  Request another plan
                </Button>
              )}
            </>
          ) : (
            <p
              style={{
                color: "red",
                fontSize: "14px",
                fontWeight: "bold",
                marginTop: "24px",
              }}
            >
              Your subscription plan not activated yet.
            </p>
          )}
        </div> */}
      </div>
      <Modal
        footer={false}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        className="subscribe_popup"
      >
        <>
          <div className="top_box">
            <h3>Please choose Membership plan</h3>
          </div>
          <div className="plan_choos_wrapper">
            <div className="package_list">
              <ul>
                {packageData &&
                  packageData?.map((data: any, index: any) => {
                    return (
                      <li key={index}>
                        <div>
                          <p>Subscription Plan {index + 1}</p>
                          <h4> {data.package}</h4>
                        </div>
                        <div>
                          <button
                            onClick={() => {
                              setSelectedOption(data);
                              setIsModalOpen(false);
                            }}
                          >
                            On Demand Services
                          </button>
                        </div>
                      </li>
                    );
                  })}
              </ul>
            </div>
          </div>
        </>
      </Modal>
      <Modal
        footer={false}
        open={isModalOpenReference}
        onOk={handleOkReference}
        onCancel={handleCancelReference}
        className="subscribe_popup"
      >
        <div style={{ padding: "60px 0" }}>
          <div className="top_box">
            <img src="/Group17939.png" alt="" />
            <h3>
              Your request is currently <br></br> being processed!
            </h3>
          </div>
          <div className="plan_choos_wrapper bg_none">
            <p className="discription">
              You can follow up using the reference ID provided.
            </p>
          </div>
          <div className="reference">
            <p>
              {" "}
              <strong>Reference ID:</strong>{" "}
              <span
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              ></span>
              {referenceId}
            </p>
            <button onClick={handleCopy}>
              <img src="/Group17935.svg" alt="" />
            </button>
          </div>
          {/* <button className="continue_btn" onClick={() => setStep1(false)}>
            Upgrade Plan
          </button> */}
        </div>
      </Modal>
    </div>
  );
}

export default OnDemandService;
